import Constants from 'expo-constants';

const backendApiUrl =
  Constants.expoConfig && Constants.expoConfig.extra
    ? Constants.expoConfig.extra.apiUrl
    : 'https://api.snapcalorie.com';

const useTestKeys = backendApiUrl.includes('staging') || backendApiUrl.includes('localhost');

export default {
  backendUrl: backendApiUrl,
  monthlyPriceKey: useTestKeys ? 'monthly-test' : 'monthly-price',
  yearlyPriceKey: useTestKeys ? 'yearly-test' : 'yearly-price',
};
